import moment from "moment";

export const DateRenderer = (value: string | Date) => {
  const parseDateTime = () => {
    if (!value) return "N/A";
    try {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    } catch (error) {
      return "Invalid Date";
    }
  };

  return <span>{parseDateTime()}</span>;
};

